// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner__z2ajX"};